import api from 'services/api'

export const Types = {
  SET_DATA: 'customer/SET_DATA',
}

const INITIAL_STATE = {}

export default function customer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.SET_DATA:
      // cli_codigo: data.cli_codigo,
      api.defaults.headers.common.cli_codigo = action.payload.code

      return { ...state, ...action.payload }
    default:
      return state
  }
}

export const Creators = {
  setCustomerData: data => ({ type: Types.SET_DATA, payload: data }),
}
